<mat-date-range-picker
  #picker
  id="shared-date-range-picker-wrapper"
  (closed)="daterangeClose()"
>
  <mat-date-range-picker-actions id="core-data-range-filter-action">
    <app-button
      id="shared-date-range-picker-action-cancel"
      [text]="'Cancel' | translate"
      [buttonType]="'textLink'"
      [isTextLinkBtn]="'true'"
      (buttonClick)="closeCalendar()"
      matDateRangePickerCancel
    >
    </app-button>
    <app-button
      id="shared-date-range-picker-action-apply"
      [text]="'Apply' | translate"
      [buttonType]="'primary'"
      (buttonClick)="closeCalendar()"
      matDateRangePickerApply
    >
    </app-button>
  </mat-date-range-picker-actions>
</mat-date-range-picker>
<mat-date-range-input
  class="date-range-inputs"
  id="shared-date-range-picker-action-seprator"
  separator="-"
  [formGroup]="range"
  [rangePicker]="picker"
>
  <input
    id="shared-date-range-picker-start-date"
    required
    matStartDate
    (dateInput)="dateSelectedStart(range.value.start)"
    formControlName="start"
  />
  <input
    id="shared-date-range-picker-end-date"
    required
    matEndDate
    (dateInput)="dateSelectedEnd(range.value.end)"
    formControlName="end"
  />
</mat-date-range-input>
